(function () {
  'use strict';

  function getToolbar() {
    return document.querySelector('[data-collection-toolbar]');
  }

  function closeAllDropdowns(except) {
    document.querySelectorAll('[data-collection-dropdown]').forEach(function (wrap) {
      if (except && wrap === except) return;
      var trigger = wrap.querySelector('[data-dropdown-trigger]');
      var panel = wrap.querySelector('[data-dropdown-panel]');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function initDropdowns() {
    document.querySelectorAll('[data-collection-dropdown]').forEach(function (wrap) {
      var trigger = wrap.querySelector('[data-dropdown-trigger]');
      var panel = wrap.querySelector('[data-dropdown-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !panel.hidden;
        closeAllDropdowns();
        panel.hidden = isOpen;
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });

      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    document.addEventListener('click', function () {
      closeAllDropdowns();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns();
    });
  }

  function buildUrlFromCurrent(updates) {
    var url = new URL(window.location.href);
    Object.keys(updates).forEach(function (key) {
      if (updates[key] === null || updates[key] === undefined || updates[key] === '') {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, updates[key]);
      }
    });
    return url.toString();
  }

  function deleteParamsMatching(url, matchers) {
    var keysToDelete = [];
    url.searchParams.forEach(function (_val, key) {
      if (matchers.some(function (matcher) {
        return key.indexOf(matcher) !== -1;
      })) {
        keysToDelete.push(key);
      }
    });
    keysToDelete.forEach(function (key) {
      url.searchParams.delete(key);
    });
    return keysToDelete.length > 0;
  }

  function navigateToResetUrl(href) {
    if (!href || href === '#') return false;
    window.location.href = href;
    return true;
  }

  function resetTagFilters() {
    var toolbar = getToolbar();
    var resetEl = toolbar && toolbar.querySelector('[data-reset="tags"]');
    var resetUrl = resetEl && resetEl.getAttribute('data-reset-url');
    if (resetUrl && navigateToResetUrl(resetUrl)) return;

    var url = new URL(window.location.href);
    var changed = deleteParamsMatching(url, ['filter.p.tag', 'filter.p.product_tag', 'filter.v.']);

    var fallbackList = document.querySelector('[data-tag-filter-fallback]');
    if (fallbackList) {
      fallbackList.querySelectorAll('[data-tag-fallback-input]').forEach(function (input) {
        input.checked = false;
      });
      if (!changed) {
        applyFallbackTagFilters();
        return;
      }
    }

    if (changed) {
      window.location.href = url.toString();
    }
  }

  function resetPriceFilters() {
    var toolbar = getToolbar();
    var resetEl = toolbar && toolbar.querySelector('[data-reset="price"]');
    var resetUrl = resetEl && resetEl.getAttribute('data-reset-url');
    if (resetUrl && navigateToResetUrl(resetUrl)) return;

    var url = new URL(window.location.href);
    var changed = deleteParamsMatching(url, ['filter.v.price', 'price.gte', 'price.lte']);

    if (changed) {
      window.location.href = url.toString();
      return;
    }

    var formEl = document.querySelector('[data-price-filter-form]');
    if (!formEl) return;
    var minInput = formEl.querySelector('[data-price-min]');
    var maxInput = formEl.querySelector('[data-price-max]');
    if (minInput) minInput.value = '';
    if (maxInput) maxInput.value = '';
  }

  function initFilterResets() {
    var toolbar = getToolbar();
    if (!toolbar) return;

    toolbar.querySelectorAll('[data-reset]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var type = el.getAttribute('data-reset');
        if (type === 'tags') resetTagFilters();
        else if (type === 'price') resetPriceFilters();
      });
    });
  }

  function initTagFilters() {
    document.querySelectorAll('[data-tag-filter-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var target = input.checked ? input.getAttribute('data-filter-url-add') : input.getAttribute('data-filter-url-remove');
        if (target) window.location.href = target;
      });
    });

    var fallbackList = document.querySelector('[data-tag-filter-fallback]');
    if (!fallbackList) return;

    var grid = document.querySelector('[data-collection-grid]');
    if (!grid) return;

    var params = new URLSearchParams(window.location.search);
    var activeTags = params.getAll('filter.p.tag');
    if (activeTags.length === 0) {
      activeTags = params.getAll('filter.p.product_tag');
    }

    fallbackList.querySelectorAll('[data-tag-fallback-input]').forEach(function (input) {
      if (activeTags.indexOf(input.value) !== -1) input.checked = true;
      input.addEventListener('change', applyFallbackTagFilters);
    });

    if (activeTags.length > 0) applyFallbackTagFilters();
  }

  function applyFallbackTagFilters() {
    var grid = document.querySelector('[data-collection-grid]');
    var checklist = document.querySelector('[data-tag-filter-fallback]');
    if (!grid || !checklist) return;

    var selected = [];
    checklist.querySelectorAll('[data-tag-fallback-input]:checked').forEach(function (input) {
      selected.push(input.value);
    });

    var items = grid.querySelectorAll('[data-collection-product]');
    var visible = 0;

    items.forEach(function (item) {
      var tagsRaw = item.getAttribute('data-product-tags') || '';
      var tags = tagsRaw ? tagsRaw.split('|') : [];
      var show = selected.length === 0 || selected.some(function (tag) {
        return tags.indexOf(tag) !== -1;
      });
      item.hidden = !show;
      if (show) visible += 1;
    });

    updateProductCount(visible, selected.length > 0);
  }

  function initSortMenu() {
    var sortMenu = document.querySelector('.collection-toolbar__sort-menu');
    if (!sortMenu) return;

    sortMenu.querySelectorAll('[data-sort-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sortValue = btn.getAttribute('data-sort-value');
        if (!sortValue) return;

        if (sortValue === 'relevance') {
          window.location.href = buildUrlFromCurrent({ sort_by: 'relevance' });
          return;
        }

        window.location.href = buildUrlFromCurrent({ sort_by: sortValue });
      });
    });
  }

  function getPriceRangeFromUrl() {
    var toolbar = getToolbar();
    if (toolbar) {
      var minCents = toolbar.getAttribute('data-price-filter-min-cents');
      var maxCents = toolbar.getAttribute('data-price-filter-max-cents');
      if (minCents || maxCents) {
        return {
          min: minCents ? parseInt(minCents, 10) : null,
          max: maxCents ? parseInt(maxCents, 10) : null,
        };
      }
    }

    var params = new URLSearchParams(window.location.search);
    var minKey = null;
    var maxKey = null;
    params.forEach(function (_val, key) {
      if (key.indexOf('filter.v.price.gte') !== -1 || key.indexOf('price.gte') !== -1) minKey = key;
      if (key.indexOf('filter.v.price.lte') !== -1 || key.indexOf('price.lte') !== -1) maxKey = key;
    });

    var min = minKey ? parseFloat(params.get(minKey)) : null;
    var max = maxKey ? parseFloat(params.get(maxKey)) : null;
    if (min == null || isNaN(min)) min = null;
    else min = Math.round(min * 100);
    if (max == null || isNaN(max)) max = null;
    else max = Math.round(max * 100);
    return { min: min, max: max };
  }

  function relevanceScore(item, priceMid, priceSpread) {
    var rating = parseFloat(item.getAttribute('data-product-rating'), 10) || 0;
    var ratingNorm = Math.max(0, Math.min(1, rating / 5));

    var priceScore = 0.5;
    if (priceMid != null && priceSpread != null && priceSpread > 0) {
      var price = parseInt(item.getAttribute('data-product-price'), 10) || 0;
      var dist = Math.abs(price - priceMid) / priceSpread;
      priceScore = 1 - Math.min(dist, 1);
    }

    return 0.65 * ratingNorm + 0.35 * priceScore;
  }

  function applyRelevanceSort() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('sort_by') !== 'relevance') return;

    var grid = document.querySelector('[data-collection-grid]');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-collection-product]'));
    if (items.length < 2) return;

    var priceRange = getPriceRangeFromUrl();
    var prices = items.map(function (item) {
      return parseInt(item.getAttribute('data-product-price'), 10) || 0;
    });
    var minPrice = Math.min.apply(null, prices);
    var maxPrice = Math.max.apply(null, prices);

    var priceMid = null;
    var priceSpread = maxPrice - minPrice;

    if (priceRange.min != null && priceRange.max != null) {
      priceMid = (priceRange.min + priceRange.max) / 2;
      priceSpread = Math.max(priceRange.max - priceRange.min, 1);
    } else if (priceSpread > 0) {
      priceMid = (minPrice + maxPrice) / 2;
    }

    items.sort(function (a, b) {
      return relevanceScore(b, priceMid, priceSpread) - relevanceScore(a, priceMid, priceSpread);
    });

    items.forEach(function (item) {
      grid.appendChild(item);
    });
  }

  function fetchCatalogTotal(callback) {
    var toolbar = getToolbar();
    if (!toolbar) return;

    var collectionUrl = toolbar.getAttribute('data-collection-url') || window.location.pathname;
    fetch(collectionUrl, { credentials: 'same-origin' })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var totalEl = doc.querySelector('[data-catalog-total]');
        var countEl = doc.querySelector('[data-collection-count]');
        var total = totalEl ? parseInt(totalEl.textContent, 10) : null;
        if (isNaN(total) && countEl) {
          var match = countEl.textContent.match(/(\d+)/);
          total = match ? parseInt(match[1], 10) : null;
        }
        if (total != null) callback(total);
      })
      .catch(function () {
        /* keep default */
      });
  }

  function updateProductCount(visibleCount, filtersActive) {
    var countEl = document.querySelector('[data-collection-count]');
    var toolbar = getToolbar();
    if (!countEl || !toolbar) return;

    var filtered = visibleCount != null ? visibleCount : parseInt(toolbar.getAttribute('data-filtered-count'), 10) || 0;
    var hasFilters = filtersActive != null ? filtersActive : toolbar.getAttribute('data-has-active-filters') === 'true';
    var total = parseInt(document.querySelector('[data-catalog-total]')?.textContent, 10) || filtered;

    if (hasFilters) {
      countEl.textContent = filtered + ' av ' + total + ' produkter';
    } else {
      countEl.textContent = filtered + ' produkter';
    }
  }

  function initProductCount() {
    var toolbar = getToolbar();
    if (!toolbar) return;

    var hasFilters = toolbar.getAttribute('data-has-active-filters') === 'true';
    if (!hasFilters) return;

    fetchCatalogTotal(function (total) {
      var totalEl = document.querySelector('[data-catalog-total]');
      if (totalEl) totalEl.textContent = String(total);
      updateProductCount(null, true);
    });
  }

  function init() {
    initDropdowns();
    initFilterResets();
    initTagFilters();
    initSortMenu();
    applyRelevanceSort();
    initProductCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
